import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/shipment/returns'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class ReturnsApi {

    static async getReportReturns({ data = { status: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getreportreturns', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getReturnDateReceive({ data = { status: undefined, skladName: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getreturndatereceive', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async confirmReportReturn({ data = { reportReturnId: undefined }, ...params }) {
        return await fetchService({ url: '/confirmreportreturn', method: 'POST', data, notify: { success: false }, ...params })
    }



    static async getReturnItems({ data = { entryIds: undefined, reportReturnsIds: undefined, returnDateReceiveIds: undefined, type: undefined, skladName: undefined, skladReturn: undefined, tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getreturns', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeReturns({ data = { returnIds: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changereturns', method: 'PATCH', data, ...params })
    }

    static async changeProductInReturn({ data = { returnId: undefined, productId: undefined, shop: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeproductreturn', method: 'PATCH', data, ...params })
    }

    static async addReturn({ data = { returnId: undefined, skladName: undefined, productId: undefined, shop: undefined, quantity: undefined }, ...params }) {
        return await fetchService({ url: '/addreturn', method: 'POST', data, ...params })
    }



    static async getReportItemsReturns({ data = { returnId: undefined, productId: undefined, shop: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/getreportitemsreturns', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getReturnByDateItemsReturns({ data = { returnId: undefined, skladName: undefined, productId: undefined, shop: undefined, quantity: undefined }, ...params }) {
        return await fetchService({ url: '/getreturnbydateitemsreturns', method: 'POST', data, notify: { success: false }, ...params })
    }

    // static async excelReturns({ data = { returnId: undefined, skladName: undefined, productId: undefined, shop: undefined, quantity: undefined }, ...params }) {
    //     return await fetchService({ url: '/excelreturns', method: 'POST', data, ...params })
    // }

}